import React from 'react'
import './new-loading-screen.css'
const NewLoadingScreen = (props) => {
    //IF STATEMENT IS A STUPID SAFETY FOR SCHOOL LOGO PROP
    if(props.logo) {
        return(
            <div className="the-new-loading-screen">
                <div className="new-loading-screen-img-wrapper">
                    {/* <div className="new-loading-logo" style={{backgroundImage: `url(./${props.logo})`}}></div> */}
                    <h5 className="submitting-text">{props.message}</h5>
                </div>
            </div>
        )
    } else {
        return(
            <div className="the-new-loading-screen">
                <div className="new-loading-screen-img-wrapper">
                    {/* <div className="new-loading-logo"></div> */}
                    <h5 className="submitting-text">{props.message}</h5>
                </div>
            </div>
        )
    }
}

export default NewLoadingScreen;